import config from 'admin-panel/config/environment';
import * as Sentry from '@sentry/ember';

export const initSentry = () => {
  Sentry.init({
    ...config.sentry,
    release: `${config.modulePrefix}@${config.APP.version}`,
  });
};
